import { useEffect, useState } from 'react';
import { ChatConversation, ConversationMessageDto } from '@endion/types';
import { findConversation as callApiFindConversation } from '../queries/conversation.query';
import { getConversationKeyFromLocalStorage } from '../utils/local-storage';

type UseGetConversationParams = { chatbotApiKey: string };

export function useFindConversation({ chatbotApiKey }: UseGetConversationParams) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null); // TODO: Type this
  const [conversation, setConversation] = useState<ChatConversation | null>(null);
  const [storedConversationHistory, setStoredConversationHistory] = useState<ConversationMessageDto[]>([]);
  const [requestId, setRequestId] = useState<string | null>(null);

  const findConversation = async () => {
    try {
      setError(null);

      const conversationKey = getConversationKeyFromLocalStorage();
      if (!conversationKey) return;

      setIsLoading(true);

      const response = await callApiFindConversation({ conversationKey, chatbotApiKey });
      setRequestId(response?.id || null); // Request id could be later used to detect when the conversation history needs to be reloaded
      const conversation = response?.data || null;

      // transform db conversation messages to the chat component format
      const storedConversationHistory: ConversationMessageDto[] = (conversation?.content?.messages || []).map((m) => ({
        ...m,
        createdAt: m.createdAt,
      }));

      setStoredConversationHistory(storedConversationHistory);
      setConversation(conversation);
      setIsLoading(false);
    } catch (e) {
      setError(e as Error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await findConversation();
    })();
  }, [chatbotApiKey]);

  return { conversation, isLoading, storedConversationHistory, error, findConversation, requestId };
}
